
export const Routes = {
    // pages
    Presentation: { path: "/" },
    Groups: { path: "/groups" },
    GroupTransactions: { path: "/groups/:groupId/transactions" },
    GroupRecordIncome: { path: "/groups/:groupId/record-income" },
    GroupRecordExpenses: { path: "/groups/:groupId/record-expenses" },
    GroupMembers: { path: "/groups/:groupId/members" },
    GroupContributionPurposes: { path: "/groups/:groupId/contribution-purposes" },
    ExpenseCategories: { path: "/expense-categories" },
    ContributionPurposes: { path: "/contribution-purposes" },
    Users: { path: "/users" },
    Settings: { path: "/settings" },
    Signin: { path: "/sign-in" },
    Signup: { path: "/sign-up" },
    ForgotPassword: { path: "/forgot-password" },
    NotFound: { path: "/404" }
};